/** Catálogo de transiciones xfade categorizadas en castellano. */

import { DYNAMIC_TRANSITIONS } from "../preview/transitionLibrary";

export interface TransitionDef {
  id: string;         // valor para FFmpeg xfade transition=...
  label: string;
  icon?: string;      // pictograma unicode opcional
}

export interface TransitionCategory {
  name: string;
  items: TransitionDef[];
}

export const TRANSITION_CATEGORIES: TransitionCategory[] = [
  {
    name: "Suaves",
    items: [
      { id: "fade",       label: "Fundido",          icon: "◌" },
      { id: "fadefast",   label: "Fundido rápido",   icon: "◌" },
      { id: "fadeslow",   label: "Fundido lento",    icon: "◌" },
      { id: "fadeblack",  label: "A negro",          icon: "●" },
      { id: "fadewhite",  label: "A blanco",         icon: "○" },
      { id: "fadegrays",  label: "A grises",         icon: "◐" },
      { id: "dissolve",   label: "Disolver",         icon: "▒" },
      { id: "distance",   label: "Distancia",        icon: "▦" },
    ],
  },
  {
    name: "Wipes (cortina)",
    items: [
      { id: "wipeleft",   label: "Wipe ←",  icon: "◀" },
      { id: "wiperight",  label: "Wipe →",  icon: "▶" },
      { id: "wipeup",     label: "Wipe ↑",  icon: "▲" },
      { id: "wipedown",   label: "Wipe ↓",  icon: "▼" },
      { id: "wipetl",     label: "Wipe ↖",  icon: "◤" },
      { id: "wipetr",     label: "Wipe ↗",  icon: "◥" },
      { id: "wipebl",     label: "Wipe ↙",  icon: "◣" },
      { id: "wipebr",     label: "Wipe ↘",  icon: "◢" },
    ],
  },
  {
    name: "Slides (deslizar)",
    items: [
      { id: "slideleft",  label: "Slide ←", icon: "←" },
      { id: "slideright", label: "Slide →", icon: "→" },
      { id: "slideup",    label: "Slide ↑", icon: "↑" },
      { id: "slidedown",  label: "Slide ↓", icon: "↓" },
    ],
  },
  {
    name: "Smooth (suave direccional)",
    items: [
      { id: "smoothleft",  label: "Smooth ←", icon: "↞" },
      { id: "smoothright", label: "Smooth →", icon: "↠" },
      { id: "smoothup",    label: "Smooth ↑", icon: "↟" },
      { id: "smoothdown",  label: "Smooth ↓", icon: "↡" },
    ],
  },
  {
    name: "Cubrir / Revelar",
    items: [
      { id: "coverleft",   label: "Cubrir ←",  icon: "⟵" },
      { id: "coverright",  label: "Cubrir →",  icon: "⟶" },
      { id: "coverup",     label: "Cubrir ↑",  icon: "⟰" },
      { id: "coverdown",   label: "Cubrir ↓",  icon: "⟱" },
      { id: "revealleft",  label: "Revelar ←", icon: "⇐" },
      { id: "revealright", label: "Revelar →", icon: "⇒" },
      { id: "revealup",    label: "Revelar ↑", icon: "⇑" },
      { id: "revealdown",  label: "Revelar ↓", icon: "⇓" },
    ],
  },
  {
    name: "Cinemáticas",
    items: [
      { id: "circleopen",  label: "Círculo abre",     icon: "⊙" },
      { id: "circleclose", label: "Círculo cierra",   icon: "⊚" },
      { id: "circlecrop",  label: "Círculo crop",     icon: "◯" },
      { id: "rectcrop",    label: "Rectángulo crop",  icon: "▭" },
      { id: "vertopen",    label: "Vertical abre",    icon: "↕" },
      { id: "vertclose",   label: "Vertical cierra",  icon: "↔" },
      { id: "horzopen",    label: "Horizontal abre",  icon: "↔" },
      { id: "horzclose",   label: "Horizontal cierra",icon: "↕" },
      { id: "squeezeh",    label: "Aplastar H",       icon: "◇" },
      { id: "squeezev",    label: "Aplastar V",       icon: "◆" },
      { id: "zoomin",      label: "Zoom in",          icon: "⊕" },
    ],
  },
  {
    name: "Creativas",
    items: [
      { id: "pixelize",   label: "Pixelado",            icon: "▦" },
      { id: "radial",     label: "Radial",              icon: "✺" },
      { id: "hblur",      label: "Difuminado",          icon: "≋" },
      { id: "diagtl",     label: "Diagonal ↖",          icon: "⤡" },
      { id: "diagtr",     label: "Diagonal ↗",          icon: "⤢" },
      { id: "diagbl",     label: "Diagonal ↙",          icon: "⤢" },
      { id: "diagbr",     label: "Diagonal ↘",          icon: "⤡" },
      { id: "hlslice",    label: "Slice ←",             icon: "⫷" },
      { id: "hrslice",    label: "Slice →",             icon: "⫸" },
      { id: "vuslice",    label: "Slice ↑",             icon: "⩓" },
      { id: "vdslice",    label: "Slice ↓",             icon: "⩔" },
      { id: "hlwind",     label: "Viento ←",            icon: "≈" },
      { id: "hrwind",     label: "Viento →",            icon: "≈" },
      { id: "vuwind",     label: "Viento ↑",            icon: "≈" },
      { id: "vdwind",     label: "Viento ↓",            icon: "≈" },
    ],
  },
  {
    // Inspiradas en gl-transitions. Sólo se ven correctas en preview;
    // en el export se degradan a fundido (no son tipos xfade nativos).
    name: "✨ Especiales (solo preview)",
    items: [
      { id: "burn",         label: "Quemar",            icon: "🔥" },
      { id: "filmburnPro",  label: "Quemar pro",        icon: "🔥" },
      { id: "glitch",       label: "Glitch / TV",       icon: "▓" },
      { id: "glitchHard",   label: "Glitch fuerte",     icon: "▓▓" },
      { id: "morph",        label: "Morfear",           icon: "≈" },
      { id: "swirl",        label: "Remolino",          icon: "🌀" },
      { id: "ripple",       label: "Onda de agua",      icon: "🌊" },
      { id: "waterdrop",    label: "Gota de agua",      icon: "💧" },
      { id: "doorway",      label: "Puerta",            icon: "⊟" },
      { id: "kaleidoscope", label: "Caleidoscopio",     icon: "✻" },
      { id: "pageCurl",     label: "Pasar página",      icon: "🗎" },
      { id: "rotateScale",  label: "Girar y escalar",   icon: "↻" },
      { id: "noiseScramble",label: "Ruido / Scramble",  icon: "▦" },
      { id: "invertFlash",  label: "Flash invertido",   icon: "✦" },
      { id: "rgbSplit",     label: "Separación RGB",    icon: "🟥" },
      { id: "scanlines",    label: "Líneas de TV",      icon: "═" },
    ],
  },
  {
    name: "✨ Patrones",
    items: [
      { id: "crosshatch",  label: "Cruces (hatch)",      icon: "✕" },
      { id: "mosaic",      label: "Mosaico",             icon: "▦" },
      { id: "polkadot",    label: "Lunares",             icon: "●" },
      { id: "hexagons",    label: "Hexágonos",           icon: "⬡" },
      { id: "diamonds",    label: "Rombos",              icon: "◆" },
    ],
  },
  {
    name: "✨ Formas",
    items: [
      { id: "squareWipe",  label: "Cuadrado",            icon: "▢" },
      { id: "starWipe",    label: "Estrella",            icon: "★" },
      { id: "plusWipe",    label: "Cruz",                icon: "✚" },
      { id: "heart",       label: "Corazón",             icon: "❤" },
      { id: "letterbox",   label: "Barras negras",       icon: "▭" },
      { id: "circleWaves", label: "Ondas circulares",    icon: "◎" },
    ],
  },
  {
    name: "✨ Blur / Distorsión",
    items: [
      { id: "dreamyZoom",  label: "Zoom soñador",        icon: "✧" },
      { id: "linearBlur",  label: "Blur lineal",         icon: "≡" },
      { id: "zoomBlur",    label: "Blur radial",         icon: "◉" },
      { id: "stretchBlur", label: "Blur estirado",       icon: "‖" },
    ],
  },
  {
    name: "✨ Persianas / Grid",
    items: [
      { id: "windowblindsH", label: "Persianas horiz.",  icon: "≣" },
      { id: "windowblindsV", label: "Persianas vert.",   icon: "Ⅲ" },
      { id: "shutterhorz",   label: "Shutter horiz.",    icon: "▤" },
      { id: "shuttervert",   label: "Shutter vert.",     icon: "▥" },
      { id: "gridflip",      label: "Grid flip",         icon: "▦" },
    ],
  },
];

/** Conjunto plano de IDs válidos (para validación). */
export const VALID_TRANSITION_IDS = new Set<string>(
  TRANSITION_CATEGORIES.flatMap((c) => c.items.map((t) => t.id)),
);

/** Buscar la def por id (busca en xfade nativas + catálogo dinámico). */
export function findTransition(id: string): TransitionDef | null {
  for (const cat of TRANSITION_CATEGORIES) {
    const found = cat.items.find((t) => t.id === id);
    if (found) return found;
  }
  const dyn = DYNAMIC_TRANSITIONS.find((t) => t.id === id);
  if (dyn) return { id: dyn.id, label: dyn.label, icon: dyn.icon };
  return null;
}

/** Default sugerido por transición (algunas se ven mejor más largas). */
export function defaultDurationMs(id: string): number {
  if (id === "zoomin" || id === "circleopen" || id === "circleclose") return 800;
  if (id === "fadeslow") return 1500;
  if (id === "fadefast") return 250;
  return 500;
}
